import { arrayMove } from "@dnd-kit/sortable";
import {
    Box,
    CircularProgress,
    Fab,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField,
    useTheme,
    Zoom
} from "@mui/material";
import React, { useEffect, useState } from "react";
import '../../App.css';

import { Add } from "@mui/icons-material";
import { generateMockOrderData } from "../../configs/mock";
import { floatBettingSymbol, multiplierSymbol, rxNumberCombination, rxNumberPermutation, rxSpace } from "../../configs/regex";
import { BetType } from "../../helpers/ticket_process/constants";
import { LotteryTicketNumberDto } from "../../helpers/ticket_process/dto/LotteryTicketNumberDto";
import { processLotteryTicketNumber } from "../../helpers/ticket_process/ticket_process.v2";
import gameService, { GameSession, OrderTicketRequestParams, TicketOrderNumber, TicketOrderRequestBody, TicketOrderRequestParams } from "../../services/game_service";
import { INumberDetail, ITicketData } from "../../services/type";
import { StyledFillButton } from "../../styled/filled_button";
import NumberInput from "../form/number_input";
import Spacer from "../spacing/spacer";
import { formatNumberString } from "../spring/string_helper";
import { sxCenter } from "../styled/styled_flex_container";
import OrderTableRow from "../table/draggable_table/static_table_row";
import { Column } from "../table/hoverable_table_row";
import '../table/ripple.css';
import PromptTypo from "../typography/typography_prompt";
import OrderTableAgentRateComponent from "./order_table_agent_rate";
import { useDialog } from "../transition_modal/dialog_provider";
import { SwalLeaveConfirm, SwalLoading } from "../dialog/swal_alert";
import { useSnackbar } from "../../stores/providers/snackbar_provider";
import { AgentRateDetails } from "../../services/rate_service";
import { PriceRateDto } from "../../helpers/ticket_process/dto/PriceRateDto";
import { Permission, SPACING_LG } from "../../configs/constants";
import { formatToCurrencyString } from "../../helpers/number_formatter_helper";
import { useOrderDialogFormState } from "../../stores/states/useOrderFormState";
import { faIR } from "date-fns/locale";
import { usePreventLeave } from "../../stores/states/useBeforeUnload";
import { useAuth } from "../../stores/providers/auth_provider";
import AlertGame from "../alerts/alert_game";
import { gameSessionState } from "../../stores/states/useGameSessionState";
import { setArrAt } from "../../helpers/array_helper";

const rxOrderInputPattern = /^[0-9+\-*/._= ]*$/;
export interface RowData {
    id: number;
    index?: number;
    type: string;
    number: string;
    amount: string;
    summary?: string;
    betType?: BetType;
    betTypeEditted?: BetType;
    numberEditedRaw?: string;
    valueEditedRaw?: string;
    positionRaw?: string;
    positionEditedRaw?: string;
    isValid?: boolean | null;
    _isValid?: boolean | null;
    isNumberEdited?: boolean | null;
    isValueEdited?: boolean | null;
    isPositionEdited?: boolean | null;
}

interface AgentOrderTableComponentProps {
    gameSession?: GameSession;
    ownerId?: string | number;
    agentId?: string | number;
    ticketId?: string | number;
    closeCallback?: () => void;
    onLeave?: () => void;
    onFormChanged?: (value?: string) => void;
}

export interface SnackbarMessage {
    message: string;
    key: number;
}


const AgentOrderTableComponent: React.FC<AgentOrderTableComponentProps> = ({
    gameSession, ownerId, agentId, ticketId, closeCallback, onLeave, onFormChanged
}) => {
    const [ticketNumber, setTicketNumber] = useState<string | number | undefined>(1);
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [agentRate, setAgentRate] = useState<PriceRateDto | null | undefined>(undefined);
    const [ticketData, setTicketData] = useState<ITicketData | null>(null);
    const [isRowProcessValid, setRowProcessValid] = useState<boolean>(false);
    const { show } = useSnackbar();
    const [sumaryNumber, setSumaryNumber] = useState<any>();
    const [discountNumber, setDiscountNumber] = useState<any>(0);
    const [totalAmountNumber, setTotalAmountNumber] = useState<any>();
    const orderRows = useOrderDialogFormState((state) => state.orderRows as RowData[]);
    const isOrderRowEdited = useOrderDialogFormState((state) => state.isOrderRowEdited);
    const setOrderRows = useOrderDialogFormState((state) => state.setOrderRows);
    const [loading, setLoading] = useState<boolean>(false);
    const { user } = useAuth();
    const setIsOrderRowEdited = useOrderDialogFormState((state) => state.setIsOrderRowEdited);
    const { checkCanCreateOrderByGameState, setCurrentGameSession, currentGameSession, } = gameSessionState();
    const columns: Column[] = [
        { label: 'ลำดับ', field: 'index', render: (field) => field + 1 },
        { label: 'ประเภท', field: 'type', render: (field, row) => renderTypeFab(row) }, // Pass entire row to renderTypeFab
        { label: 'เลข', field: 'number', render: (field, row) => numberTextField(row) },
        { label: 'ราคา', field: 'amount', render: (field, row) => amountTextField(row) },
        {
            label: 'รวม', field: 'formattedSummary', render: (field) =>
                <PromptTypo
                    align="right"
                    sx={{
                        minWidth: '100px',
                        maxWidth: '200px',
                        padding: '0px 16px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        color: muiTheme.palette.primary.main
                    }}>{field}</PromptTypo>,
            align: 'right',
        },

    ];
    usePreventLeave(isOrderRowEdited);
    function createLotteryTicket(row: RowData, index: number): LotteryTicketNumberDto {
        return {
            numberRaw: row.number,
            valueRaw: row.amount,
            positionRaw: row.type,
            betTypeRaw: row.betType,
            betTypeEditedRaw: row.betTypeEditted,
            numberEditedRaw: row.numberEditedRaw,
            valueEditedRaw: row.valueEditedRaw,
            positionEditedRaw: row.positionEditedRaw,
            rowIndex: index,
            _isEdited: undefined,
            _isValid: undefined,
            _betTypeRaw: undefined,
            _betTypeEditedRaw: undefined,
            _appliedNumbers: undefined,
            _totalAmount: undefined,
            _messages: undefined
        };
    }


    function processRow(row: RowData, index: number, forcedValidate?: boolean) {
        const lotteryTicket = createLotteryTicket(row, index);
        const processedTicket = processLotteryTicketNumber(lotteryTicket);

        const totalAmount = processedTicket._totalAmount ?? 0;
        const summaryMessage = processedTicket._messages?.join(", ") || "Valid";
        setRowProcessValid(processedTicket._isValid === true);
        return {
            ...row,
            summary: summaryMessage,
            summaryRowCurrency: summaryMessage === '' ? formatToCurrencyString(summaryMessage, 'en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 }) : '',
            isValid: determineValidity(row, processedTicket, forcedValidate),
            appliedNumbers: processedTicket._appliedNumbers,
            totalAmount
        };
    }

    function exactlyOneEmpty(...fields: string[]): boolean {
        const emptyCount = fields.filter(f => f.trim() === "").length;
        return emptyCount === 1;
    }

    function determineValidity(row: RowData, processedTicket: any, forcedValidate?: boolean) {
        if (forcedValidate === true || forcedValidate === false) {
            return forcedValidate;
        }
        return (row.number === '' && row.amount === '') ? true : processedTicket._isValid;
    }

    function formatSummary(totalAmount: number): string {
        const summaryToInteger = (Number(totalAmount) >= 0 ? Number(totalAmount) : '') ?? '';
        return `${summaryToInteger}`;
    }

    function handleInputChange(id: number, field: keyof RowData, value: string, forcedValidate?: boolean, isFromFocusedOut?: boolean) {
        // const ifSomeEmpty = exactlyOneEmpty(orderRows[id]?.number ?? "", orderRows[id]?.amount ?? "");
        if (value !== '' && isFromFocusedOut !== true) {
            setIsOrderRowEdited(true);
            onFormChanged?.(value ?? '');
        }
        setOrderRows(
            orderRows.map((row, index) => {
                if (row.id === id) {
                    const updatedRow = { ...row, [field]: value };
                    const processedRow = processRow(updatedRow, index, forcedValidate);
                    const summaryRow = formatSummary(processedRow.totalAmount);
                    const summaryRowCurrency = summaryRow ? formatToCurrencyString(summaryRow, 'en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 }) : '';
                    return {
                        ...processedRow,
                        summary: summaryRow,
                        formattedSummary: summaryRowCurrency
                    };
                }
                return row;
            })
        );
    }

    function setAmountFromPrevRow(index: number) {
        if (index <= 0 || index >= orderRows.length) return '';
        const refValue = orderRows[index - 1].amount ?? '';
        const isEmptyNumber = orderRows[index].number === '';
        return isEmptyNumber ? '' : refValue;
    }

    function handleOnFocusedOut(
        event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
        id: number,
        field: keyof RowData
    ) {
        const matchedRow = orderRows.find((row) => row.id === id);
        let value = event.target.value;
        let trimValue = value.trim();
        let newValue = trimValue.replace(rxSpace, '');
        let result = '';
        if (field === 'number') {
            if (newValue.length >= 6) {
                if (!newValue.includes(multiplierSymbol) &&
                    !newValue.includes(floatBettingSymbol)
                ) {
                    handleInputChange(id, 'number', '');
                    return;
                }
            }
            const numberWithPermutationSign = newValue.match(rxNumberPermutation);
            result = numberWithPermutationSign ? numberWithPermutationSign[0] : '';
        }

        if (field === 'amount') {
            const numberWithCombinationSign = newValue.match(rxNumberCombination);
            result = numberWithCombinationSign ? numberWithCombinationSign[0] : '';
            if (id !== 0 && (result === '' || !result)) {
                result = setAmountFromPrevRow(id);
            }
        }

        const isNumberEmpty = matchedRow?.number.trim() === "";
        const isAmountEmpty = matchedRow?.amount.trim() === "";
        const ifSomeEmpty = exactlyOneEmpty(matchedRow?.number ?? "", matchedRow?.amount ?? "");

        if (isNumberEmpty && isAmountEmpty) {
            handleInputChange(id, 'number', result);
            handleInputChange(id, 'amount', result);
            return;
        }
        handleInputChange(id, field, result, undefined, true);
    }

    function removeEmptyRow(numbers: TicketOrderNumber[]) {
        return numbers.filter((f) => f.numberRaw !== '' && f.valueRaw !== '')
    }

    function getIsFormValid(numbers: TicketOrderNumber[]) {
        return !orderRows.find((f => f.isValid === false));
    }

    const handleSubmitTicketOrder = async () => {
        const tempNumber = orderRows.map(((row, index) => {
            const result = {
                numberRaw: `${row.number}`,
                valueRaw: `${row.amount}`,
                positionRaw: `${row.type}`,
                betType: `${row.betType}`,
                rowIndex: index,
                isValid: row.isValid === true,
                numberEditedRaw: `${row.number}`,
                valueEditedRaw: `${row.amount}`,
                positionEditedRaw: `${row.type}`,
                ...(!ticketId ? {} : {
                    numberEditedRaw: `${row.numberEditedRaw}`,
                    valueEditedRaw: `${row.valueEditedRaw}`,
                    positionEditedRaw: `${row.positionEditedRaw}`,
                }),
            };

            return result;
        }));
        const reqBody: TicketOrderRequestBody = {
            sequence: `${ticketNumber ?? 1}`,
            numbers: removeEmptyRow(tempNumber)
        }
        const reqParams: TicketOrderRequestParams = {
            gameId: `${gameSession!?.id}`,
            agentId: `${agentId}`,
        }
        if (!getIsFormValid(reqBody.numbers)) {
            show('กรุณากรอกข้อมูลให้ถูกต้อง', true)
            return;
        }
        if (ticketId) {

            await gameService.updateTicketOrder(
                reqBody,
                {
                    ...reqParams,
                    ticketId: `${ticketId}`
                }
            );
            closeCallback?.();
        } else {
            await gameService.createTicketOrder(reqBody, reqParams);
            closeCallback?.();
        }
    }

    const fetchTicketNewOrder = async () => {
        const params: OrderTicketRequestParams = {
            gameId: `${gameSession?.id}`,
            agentId: `${agentId}`,
        }
        setIsOrderRowEdited(false);
        onFormChanged?.(undefined);
        await gameService.getTicketOrderByNewTicket(params).then(async (res) => {
            generateEmptyTicketForm();
            setAgentRate(undefined);
            const data = res?.data;
            setTicketData(res?.data ?? null)
            setTicketNumber(data?.sequence ?? 1);
            setAgentRate(data?.priceRates ?? null);
        }).catch((_) => {
            setTicketData(null);
        })
    }

    const fetchTicketIdOrder = async (ticketById?: string | number) => {
        const params: OrderTicketRequestParams = {
            gameId: `${gameSession?.id}`,
            agentId: `${agentId}`,
            ticketId: `${ticketById ? ticketById : ticketId}`
        }
        setIsOrderRowEdited(false);
        onFormChanged?.(undefined);
        try {
            setAgentRate(undefined);
            gameService.getTicketOrderByTicketId(params).then((res) => {
                const data = res?.data;
                setTicketData(data ?? null);
                mapRawDataToForm(res?.data!);
                setAgentRate(data?.priceRates ?? null);
                setTicketNumber(data?.sequence ?? 1);
                setDiscountNumber((data?.betAmount ?? 0) - (data?.deductAmount ?? 0));
            })
        } catch (error) { }
    }
    function mapRawDataToForm(res: ITicketData) {
        const nums = res?.numbers;
        if (!nums?.length) return;

        try {
            const tempRows: RowData[] = nums.map((num, index) => {
                const updatedRow: RowData = {
                    index,
                    id: num.rowIndex,
                    type: num.positionRaw,
                    number: num.numberRaw,
                    amount: num.valueRaw,
                    positionRaw: num.positionRaw,
                    numberEditedRaw: num.numberEditedRaw,
                    valueEditedRaw: num.valueEditedRaw,
                    positionEditedRaw: num.positionEditedRaw,
                    isNumberEdited: num.numberRaw !== num.numberEditedRaw,
                    isValueEdited: num.valueRaw !== num.valueEditedRaw,
                    isPositionEdited: num.positionRaw !== num.positionEditedRaw,
                    // betType: num.betTypeRaw,
                };

                const processedRow = processRow(updatedRow, index);
                const summaryRow = formatSummary(processedRow.totalAmount);
                const summaryRowCurrency = summaryRow ? formatToCurrencyString(summaryRow, 'en-US', { maximumFractionDigits: 0, minimumFractionDigits: 0 }) : '';
                return {
                    ...processedRow,
                    summary: summaryRow,
                    formattedSummary: summaryRowCurrency
                };
            });
            setOrderRows(tempRows);
            setTicketNumber(res?.sequence ?? 1);
        } catch (error) {
            console.error("Error in mapRawDataToForm:", error);
        }
    }

    useEffect(() => {
        const totalAmount = orderRows.reduce((sum: number, row: RowData) => sum + (Number(row.summary) || 0), 0);
        setSumaryNumber(totalAmount);
    }, [orderRows])

    // Function to add 5 new rows
    function addRows(): void {
        const newRows: RowData[] = [];
        const startId = orderRows.length; // Determine the starting ID for new rows
        for (let i = 0; i < 10; i++) {
            newRows.push({
                id: startId + i,
                index: startId + i,
                type: "บ",
                number: "",
                amount: "",
                isValid: null
            });
        }
        setOrderRows([...orderRows, ...newRows]);
    }

    const toggleType = (id: number) => {
        orderRows.map((row) => {
            if (row.id === id) {
                handleInputChange(id, "type", row.type === "บ" ? "ล" : row.type === "ล" ? "บ+ล" : "บ");
            }
        })
    };

    const muiTheme = useTheme();

    const typeColorTransform = (type: string) => {
        if (type === 'บ') return <PromptTypo fontWeight='bold'>บ</PromptTypo>
        else if (type === 'ล') return <PromptTypo fontWeight='bold' color={muiTheme.palette.error.main}>ล</PromptTypo>
        else if (type === 'บ+ล') return <Stack direction={'row'}>
            <PromptTypo fontWeight='bold'>บ</PromptTypo>
            <PromptTypo fontWeight='bold' color={muiTheme.palette.text.secondary}>+</PromptTypo>
            <PromptTypo fontWeight='bold' color={muiTheme.palette.error.main}>ล</PromptTypo>
        </Stack>
    }

    const renderTypeFab = (row: RowData) => (
        <Fab
            disabled={!agentRate}
            tabIndex={-1}
            onClick={() => {
                toggleType(row.id); // Call toggleType with the row's id
            }}
            sx={{
                bgcolor: muiTheme.palette.background.paper,
                color: muiTheme.palette.secondary.light,
                ":hover": { bgcolor: muiTheme.palette.background.default }
            }}
            size="small"
        >
            {typeColorTransform(row.type)}
        </Fab>
    );

    const orderTransform = (value: string): string => {
        const lastestText = value[value.length - 1];
        const isLastTextNumber = !isNaN(Number(lastestText));

        if (isLastTextNumber || lastestText === '0') {
            return value;
        }
        if (lastestText === ' ') {
            return '';
        }
        const symbolMap: { [key: string]: string } = {
            '*': '*',
            '-': '-',
            'x': '*',
            ' ': '',
        };
        return value.slice(0, -1) + (symbolMap[lastestText] || '');
    };

    const numberTextField = (row: RowData) => <TextField
        sx={{
            minWidth: "100px",
            "& .MuiInputBase-input": {
                color:
                    row.isNumberEdited
                        ? muiTheme.palette.error.light
                        : muiTheme.palette.primary.main,

                "&:focus": {
                    color: muiTheme.palette.primary.main,
                },
            },
        }}
        autoComplete="off"
        variant="outlined"
        size="small"
        value={row.number}
        onClick={(e) => e.stopPropagation()}
        disabled={!agentRate}
        onBlur={(e) => {
            handleOnFocusedOut(e, row.id, 'number');
        }}
        onChange={(e) => {
            let newValue = e.target.value;
            if (newValue.endsWith(' ')) {
                toggleType(row.id)
                newValue = e.target.value.trim();
            }
            const transformedValue = orderTransform(newValue);
            handleInputChange(row.id, "number", transformedValue);
        }}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
                const inputs = document.querySelectorAll('input');
                const index = Array.from(inputs).indexOf(e.target as HTMLInputElement);
                if (index >= 0 && index < inputs.length - 1) {
                    (inputs[index + 1] as HTMLInputElement).focus();
                }
            }
            if (e.key === ' ') { // Check if the SPACE_BAR is pressed
                e.preventDefault(); // Prevent default scrolling behavior
                toggleType(row.id); // Call toggleType with the row's id
            }
        }}
    />

    const amountTextField = (row: RowData) => <TextField
        sx={{
            minWidth: "100px",
            "& .MuiInputBase-input": {
                color:
                    row.isValueEdited
                        ? muiTheme.palette.error.light
                        : muiTheme.palette.primary.main,

                "&:focus": {
                    color: muiTheme.palette.primary.main,
                },
            },
        }}
        autoComplete="off"
        variant="outlined"
        disabled={!agentRate}
        size="small"
        value={row.amount}
        onClick={(e) => e.stopPropagation()}
        onBlur={(e) => {
            handleOnFocusedOut(e, row.id, 'amount');
        }}
        // slotProps={{
        //     input: {
        //         style:
        //             row.amount !== row.valueEditedRaw ?
        //                 { color: `${muiTheme.palette.error.light}` } :
        //                 { color: `${muiTheme.palette.primary.main}` },
        //     },
        // }}
        onChange={(e) => {
            let newValue = e.target.value;
            if (newValue.endsWith(' ')) {
                toggleType(row.id)
                newValue = e.target.value.trim();
            }
            const transformedValue = orderTransform(newValue);
            handleInputChange(row.id, "amount", transformedValue);
        }}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
                const inputs = document.querySelectorAll('input');
                const index = Array.from(inputs).indexOf(e.target as HTMLInputElement);
                if (index >= 0 && index < inputs.length - 1) {
                    (inputs[index + 1] as HTMLInputElement).focus();
                }
            }
            if (e.key === ' ') { // Check if the SPACE_BAR is pressed
                e.preventDefault(); // Prevent default scrolling behavior
                toggleType(row.id); // Call toggleType with the row's id
            }
        }}
    />

    const renderRateTable = () => {
        const { nextTicketId, previousTicketId } = ticketData?.links ?? {};
        return <Box sx={{ height: 'calc(100% -100px)' }}>
            <Stack
                direction="row"
                spacing={0}
                sx={{
                    flexWrap: "nowrap",
                    alignItems: "center", justifyItems: 'space-between',
                    padding: 3
                }}>
                <PromptTypo width={'150px'}>โพยใบที่</PromptTypo>
                <NumberInput
                    nextDisabled={!!!nextTicketId || !ticketId}
                    prevDisabled={!!!previousTicketId || !ticketId}
                    onNumberDecreased={() =>
                        fetchTicketIdOrder(previousTicketId)
                    }
                    onNumberIncreased={() =>
                        fetchTicketIdOrder(nextTicketId)
                    }
                    onNumberChanged={(number) => setTicketNumber(number)}
                    value={Number(ticketNumber)} />
            </Stack>
            <Box sx={{ height: '100%', overflow: 'auto' }}>
                <Spacer size="lg" />
                <OrderTableAgentRateComponent
                    priceRate={agentRate}
                    summaryPrice={sumaryNumber}
                    gameSession={gameSession}
                    ownerId={ownerId}
                    agentId={agentId}
                />
            </Box>
        </Box>
    }


    const renderTicketOrderTable = () => {
        return (<Box sx={{
            width: '100%',
            margin: 0,
            padding: 0,
        }}>
            <Paper sx={{ ...sxCenter, width: '100%', paddingRight: SPACING_LG, paddingLeft: SPACING_LG, flexDirection: 'column' }}>
                <Box sx={{ ...sxCenter, width: '100%', position: 'relative', top: 0, zIndex: 999999, boxShadow: 'unset' }}>
                    <AlertGame gameSession={gameSession} variant="filled" size="large" fullWidth />
                </Box>
                <OrderTableRow rows={orderRows} columns={columns} />
                <Spacer size="xl" />
                <Fab sx={{ position: 'relative', zIndex: 99999, bottom: 0 }}
                    onClick={addRows}
                >
                    <Add />
                </Fab>
                <Spacer size="xl" />
            </Paper>
        </Box >)
    }

    const renderTicketSummary = () => {
        return (
            <TableContainer
                component={Paper}
                sx={{
                    minHeight: '150px'
                }}
            >
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell
                                sx={{
                                    fontSize: { xs: '0.7rem', sm: '0.8rem', lg: '0.85rem' }, // Reduced font sizes for general responsiveness
                                    '@media (max-width: 1440px) and (min-width: 1200px)': {
                                        fontSize: '0.8rem', // Further reduced size for this width range
                                    },
                                }}
                            >
                                ยอดซื้อ
                            </TableCell>
                            <TableCell
                                align="right"
                                sx={{
                                    fontSize: { xs: '0.7rem', sm: '0.8rem', lg: '0.85rem' },
                                    '@media (max-width: 1440px) and (min-width: 1200px)': {
                                        fontSize: '0.8rem',
                                    },
                                }}
                            >
                                <strong>
                                    {formatNumberString(`${sumaryNumber ?? 0}`)} บาท
                                </strong>
                            </TableCell>
                        </TableRow>
                        {ticketId && (
                            <TableRow>
                                <TableCell
                                    sx={{
                                        fontSize: { xs: '0.7rem', sm: '0.8rem', lg: '0.85rem' },
                                        '@media (max-width: 1440px) and (min-width: 1200px)': {
                                            fontSize: '0.8rem',
                                        },
                                    }}
                                >
                                    ส่วนลด
                                </TableCell>
                                <TableCell
                                    sx={{
                                        color: muiTheme.palette.error.light,
                                        fontSize: { xs: '0.7rem', sm: '0.8rem', lg: '0.85rem' },
                                        '@media (max-width: 1440px) and (min-width: 1200px)': {
                                            fontSize: '0.8rem',
                                        },
                                    }}
                                    align="right"
                                >
                                    <strong>
                                        {formatNumberString(`${discountNumber ?? 0}`)} บาท
                                    </strong>
                                </TableCell>
                            </TableRow>
                        )}
                        <TableRow>
                            <TableCell
                                sx={{
                                    fontWeight: 'bold',
                                    fontSize: { xs: '0.7rem', sm: '0.8rem', lg: '0.85rem' },
                                    '@media (max-width: 1440px) and (min-width: 1200px)': {
                                        fontSize: '0.8rem',
                                    },
                                }}
                            >
                                ยอดรวม
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: muiTheme.palette.secondary.light,
                                    fontWeight: 'bold',
                                    fontSize: { xs: '0.7rem', sm: '0.8rem', lg: '0.85rem' },
                                    '@media (max-width: 1440px) and (min-width: 1200px)': {
                                        fontSize: '0.8rem',
                                    },
                                }}
                                align="right"
                            >
                                <strong>
                                    {formatNumberString(`${totalAmountNumber ?? 0}`)} บาท
                                </strong>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

            </TableContainer>
        )
    }

    const checkPermissionCreateOrEdit = () => {
        if (ticketId) {
            return user.permissions.includes(Permission.GAME_LOTTERY_EDIT)
        }
        else return user.permissions.includes(Permission.GAME_LOTTERY_CREATE)
    }

    const generateEmptyTicketForm = async () => {
        setLoading(true);
        const emptyRowsData = await generateMockOrderData(100);
        setTimeout(() => {
            setOrderRows(emptyRowsData);
            setLoading(false);
        }, 500);
    }

    useEffect(() => {
        setTotalAmountNumber(sumaryNumber - discountNumber);
    }, [sumaryNumber, discountNumber])

    useEffect(() => {
        if (ticketId) {
            fetchTicketIdOrder(ticketId);
        }
        else fetchTicketNewOrder();
    }, []);

    useEffect(() => {
        const isValid = orderRows.every((row) => {
            const isEmpty = row.number === "" && row.amount === "";
            const isFilledCorrectly = row.number !== "" && row.amount !== "";

            return isEmpty || (isFilledCorrectly && row.isValid === true);
        });

        setIsFormValid(isValid);
    }, [orderRows]);
    if (agentRate === null) {
    }
    return (
        <Stack
            direction={{ md: "column", lg: "row" }}
            sx={{
                overflowY: { lg: 'hidden', md: 'auto' },
                // height: { lg: '85vh', md: 'auto' },
                bgcolor: muiTheme.palette.background.paper,
            }}>

            <Box
                sx={{
                    width: { xs: "100%", md: "100%", lg: "20%" },
                    p: 2,
                    minWidth: '320px',
                }}>
                <Zoom in={!loading}>
                    {renderRateTable()}
                </Zoom>

            </Box>
            <Box
                sx={{
                    height: { lg: '85vh', md: 'auto' },
                    minHeight: '500px',
                    width: { xs: "100%", md: "100%", lg: "60%" },
                    overflowY: "auto",
                    p: 2,
                }}>
                <Box sx={{ height: "auto" }}>
                    {loading ?
                        <Box sx={{ ...sxCenter, height: '375px' }}>
                            <CircularProgress />
                        </Box> :
                        <Zoom in={!loading}>
                            {renderTicketOrderTable()}
                        </Zoom>
                    }
                </Box>
            </Box>
            <Box
                sx={{
                    width: { xs: "100%", md: "100%", lg: "20%" },
                    p: 2,
                }}>
                <Zoom in={!loading}>
                    {renderTicketSummary()}
                </Zoom>
                <Spacer size="lg" />
                <Zoom in={!loading}>
                    <StyledFillButton

                        fullWidth
                        sx={{
                            color: muiTheme.palette.common.white,
                            bgcolor: muiTheme.palette.secondary.main,
                            ":hover": { color: muiTheme.palette.secondary.light }
                        }}
                        onClick={handleSubmitTicketOrder}
                        disabled={
                            !isFormValid ||
                            !agentRate ||
                            isOrderRowEdited === false ||
                            !checkPermissionCreateOrEdit() ||
                            !checkCanCreateOrderByGameState(user.roleCode, currentGameSession)
                        }>
                        บันทึก
                    </StyledFillButton>
                </Zoom>
                <Spacer size='md' />
                <Zoom in={!loading}>
                    <StyledFillButton
                        fullWidth
                        sx={{
                            color: muiTheme.palette.common.white,
                            bgcolor: `${muiTheme.palette.error.main}`,
                            ":hover": {
                                color: muiTheme.palette.error.light,
                                bgcolor: `${muiTheme.palette.error.dark}35`,
                            }
                        }}
                        onClick={
                            () => isOrderRowEdited ? SwalLeaveConfirm(
                                () => () => {
                                    setIsOrderRowEdited(false);
                                    return onLeave?.();
                                },
                                () => {
                                    setIsOrderRowEdited(false);
                                    return onLeave?.();
                                }
                            ) : onLeave?.()
                        }>
                        ยกเลิก
                    </StyledFillButton>
                </Zoom>
            </Box>
        </Stack >
    );
};

export default AgentOrderTableComponent;
